<!-- =========================================================================================
  File Name: AttendeeEdit.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-edit" class="attendee-form-wrap">
    <div class="vx-row">
      <div class="vx-col md:w-4/12 w-full">
        <label>
          Name
          <span class="rqrd">*</span>
        </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="text"
          v-validate="'required'"
          v-model="menuName"
          name="Name"
        />
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{
          errors.first("Name")
        }}</span>
      </div>

      <div class="vx-col md:w-4/12 w-full">
        <label>
          Display Label
          <span class="rqrd">*</span>
        </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="text"
          v-model="displayLabel"
          v-validate="'required'"
          name="displayLabel"
        />
        <span class="text-danger text-sm" v-show="errors.has('displayLabel')">{{
          errors.first("displayLabel")
        }}</span>
      </div>

      <div class="vx-col md:w-4/12 w-full">
        <label> Page Url </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="text"
          v-model="pageUrl"
          name="pageUrl"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> Display Label (German) </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="text"
          v-model="displayLabel_de"
          name="displayLabel_de"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> DisplayLabel (French) </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="text"
          v-model="displayLabel_fr"
          name="displayLabel_fr"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> DisplayLabel (Chinese) </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="text"
          v-model="displayLabel_zh"
          name="displayLabel_zh"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> Display Order </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="number"
          v-model="displayOrder"
          name="displayOrder"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> Menu ID </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="number"
          v-model="menuId"
          name="menuId"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> Group ID </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="number"
          v-model="groupId"
          name="groupId"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label> Position In Page </label>
        <vs-input
          autocomplete="off"
          class="w-full mt-4"
          type="number"
          v-model="positionInPage"
          name="PositionInPage"
        />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label class="mr-3">Is Published</label>
        <vs-switch class="mt-4" v-model="isPublished" />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label class="mr-3">Is Optional</label>
        <vs-switch class="mt-4" v-model="isOptional" />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label class="mr-3">Is Editable</label>
        <vs-switch class="mt-4" v-model="isEditable" />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-4">
        <label class="mr-3">Position Is Editable</label>
        <vs-switch class="mt-4" v-model="positionIsEditable" />
      </div>

      <div class="vx-col md:w-4/12 w-full mt-0">
        <label>Upload Icon</label>
        <div class="mt-2 bg-img-path mb-4">
          <img :src="imgIconSrc" class="mr-8 rounded h-24 w-24" />
          <vs-input
            class="inputx w-full"
            name="menuIconImagePath"
            v-model="imgIconSrc"
          />
          <label class="upload-files">
            <input
              type="file"
              ref="menuIconUpload_input"
              @change="
                menuIconUpload($event, 'menuIconImagePath', 'imgIconSrc')
              "
              accept="image/*"
            />
            <span>Upload</span>
          </label>
        </div>
      </div>

      <div class="vx-col md:w-6/12 w-full mt-2">
        <label>Select Feature <span class="rqrd">*</span></label>

        <div class="hotspot-imagelink-box-wrap">
          <v-select
            class="md:w-11/12"
            placeholder="select feature"
            :options="featureList"
            label="Name"
            v-model="featureName"
            v-validate="'required'"
            name="feature"
          />
          <vs-button
            color="primary"
            type="filled"
            @click="popupAddFeature = true"
            size="small"
            class="ml-3"
            >Add</vs-button
          >

          <span class="text-danger text-sm" v-show="errors.has('feature')">{{
            errors.first("feature")
          }}</span>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
          <vs-button class="mt-2" @click="$router.push('/menu/list')"
            >Back To List</vs-button
          >

          <!-- <vs-button
            class="ml-auto mt-2"
            type="border"
            color="warning"
            @click="reset_data"
            >Reset</vs-button
          > -->
          <vs-button
            class="ml-4 mt-2"
            @click="before_save(false)"
            :disabled="!validateForm"
            color="success"
            >Save</vs-button
          >
        </div>
      </div>
    </div>

    <vs-popup title="Add Features" :active.sync="popupAddFeature">
      <label>
        Name
        <span class="rqrd">*</span>
      </label>
      <vs-input
        autocomplete="off"
        class="w-full mt-4"
        type="text"        
        v-model="newFeatureName"
        name="newFeatureName"
      />
      <!-- <span class="text-danger text-sm" v-show="errors.has('newFeatureName')"
        >The Name is Required</span
      > -->

      <label class="mr-3 mt-2">Is Default</label>
      <vs-switch class="mt-4" v-model="isFeatureDefault" />

      <vs-button class="mt-2" @click="popupAddFeature = false"
        >Back To List</vs-button
      >

      <vs-button
        class="ml-4 mt-2"
        @click="addNewFeature()"
        :disabled="newFeatureName == ''"
        color="success"
        >Save</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moduleMenuManagement from "@/store/menu-management/moduleMenuManagement.js";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      newFeatureName: "",
      isFeatureDefault: false,
      popupAddFeature: false,
      menuName: "",
      displayLabel: "",
      pageUrl: "",
      displayLabel_de: "",
      displayLabel_fr: "",
      displayLabel_zh: "",
      displayOrder: 0,
      menuId: 0,
      groupId: 0,
      positionInPage: 0,
      isPublished: false,
      isOptional: false,
      isEditable: false,
      positionIsEditable: false,
      imgIconSrc: "",
      featureName: "",
      featureId: 0,
      featureList: [],
    };
  },
  watch: {},
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    addNewFeature() {
      if(!this.newFeatureName) return false;
      this.$vs.loading();
      this.$store
        .dispatch("moduleMenuManagement/addNewFeature", {
          Name: this.newFeatureName,
          IsDefault: this.isFeatureDefault,
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Feature",
            text: "Feature Added successfully",
          });
          this.$vs.loading.close();
          this.popupAddFeature = false;
          (this.newFeatureName = ""),
            (this.isFeatureDefault = false),
            this.fetchFeatures();
          // this.$router.push("/menu/list");
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
          this.$vs.notify({
            color: "warning",
            //title: "Status Changed",
            text: "Something went wrong!",
          });
          this.popupAddFeature = false;
        });
    },
    fetchFeatures() {
      this.$store.dispatch("moduleMenuManagement/fetchFeatures").then((res) => {
        res.map((feature) => {
          this.featureList.push(feature);
        });
      });
    },
    getHighestMenuId() {
      this.$store
        .dispatch("moduleMenuManagement/getHighestMenuId")
        .then((res) => {
          this.menuId = res + 1;
        });
    },

    before_save(form_continue = false) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          if (!this.validateForm) return;

          this.saveMenu(form_continue);
        }
      });
    },
    saveMenu() {
      var obj = {};

      obj.MenuID = parseInt(this.menuId);
      obj.Name = this.menuName;
      obj.DisplayLabel = this.displayLabel;
      obj.DisplayLabel_de = this.displayLabel_de;
      obj.DisplayLabel_fr = this.displayLabel_fr;
      obj.DisplayLabel_zh = this.displayLabel_zh;
      obj.DisplayOrder = parseInt(this.displayOrder);
      obj.FeatureID = this.featureName.ID;
      obj.FeatureName = this.featureName.Name;
      obj.GroupID = parseInt(this.groupId);
      obj.IconUrl = this.imgIconSrc;
      obj.IsEditable = this.isEditable;
      obj.IsOptional = this.isOptional;
      obj.IsPublished = this.isPublished;
      obj.PageUrl = this.pageUrl;
      obj.PositionInPage = parseInt(this.positionInPage);
      obj.PositionIsEditable = this.positionIsEditable;
      this.$vs.loading();
      this.$store
        .dispatch("moduleMenuManagement/addOrUpdateMenu", {
          data: obj,
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Menu",
            text: "Menu Added successfully",
          });
          this.$vs.loading.close();
          this.$router.push("/menu/list");
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
          this.$vs.notify({
            color: "warning",
            //title: "Status Changed",
            text: "Something went wrong!",
          });
        });
    },
    menuIconUpload(input, fieldName, fieldsrc) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadFile(bgImgfile, fieldName, fieldsrc);
          this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("moduleMenuManagement/uploadImage", {
          file: file,
          path: "/OA_UAT/Image",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.imgIconSrc = res;
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    if (!moduleMenuManagement.isRegistered) {
      this.$store.registerModule("moduleMenuManagement", moduleMenuManagement);
      moduleMenuManagement.isRegistered = true;
    }
    this.fetchFeatures();
    this.getHighestMenuId();
  },
};
</script>